import{jsonOptions as jsonOptionsInternal}from"./jsonOptions";export const jsonOptions={...jsonOptionsInternal};